"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataListLabelPropDefs = exports.dataListItemPropDefs = exports.dataListPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const alignValues = ['start', 'center', 'end', 'baseline', 'stretch'];
const orientationValues = ['horizontal', 'vertical'];
const sizes = ['1', '2', '3'];
const dataListPropDefs = {
    orientation: {
        type: 'enum',
        className: 'rt-r-orientation',
        values: orientationValues,
        default: 'horizontal',
        responsive: true,
    },
    size: {
        type: 'enum',
        className: 'rt-r-size',
        values: sizes,
        default: '2',
        responsive: true,
    },
    ...index_js_1.gapProps,
    gap: {
        ...index_js_1.gapProps.gap,
        default: '4',
    },
    trim: {
        ...index_js_1.trimProp,
        className: 'rt-r-trim', // Custom trim styles due to grid layout
    },
};
exports.dataListPropDefs = dataListPropDefs;
const dataListItemPropDefs = {
    align: {
        type: 'enum',
        className: 'rt-r-ai',
        values: alignValues,
        default: undefined,
        responsive: true,
    },
};
exports.dataListItemPropDefs = dataListItemPropDefs;
const dataListLabelPropDefs = {
    ...index_js_1.widthPropDefs,
    color: index_js_1.colorProp,
    highContrast: index_js_1.highContrastProp,
};
exports.dataListLabelPropDefs = dataListLabelPropDefs;
//# sourceMappingURL=data-list.props.js.map